module.exports = __webpack_public_path__ + "img/birds.255a93ca.png";